module.exports = __webpack_public_path__ + "img/level_two_hover.e864d005.png";